import { commonUtil } from '@/util'

const request = {}

request.createRequest = function ({
  clientData,
  registerProductList,
  totalList,
  privateRemarks,
  clientRemarks
}) {
  // 選択商品情報
  const tmpProductList = registerProductList.map((ele) => {
    return {
      productId: ele.productId,
      quantity: String(Number(ele.count)),
      price: String(Number(ele.price)),
      exportSubjectFlg: ele.exportSubjectFlg
    }
  })

  const result = {
    // 顧客情報
    customerId: clientData.clientInfo.customerId,
    billingName: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.fullName
    ),
    billingOrganizationName: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.organizationName
    ),
    billingAddressCountryId: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.country.value
    ),
    billingPostalCode: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.postalCode
    ),
    billingRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.invoiceInfo.region, true)
    ),
    billingRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.invoiceInfo.region, false)
    ),
    billingAddress1: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.address1
    ),
    billingAddress2: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.address2
    ),
    billingPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.phone.countryCode.value
    ),
    billingPhoneNumber: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.phone.phoneNumber
    ),
    addCustomerRecipientFlg: clientData.receiverInfo.addReceiverInfo || false,

    // 受取人
    // recipientId: clientData.receiverInfo.receiverId,
    recipientName: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.fullName
    ),
    recipientOrganizationName: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.organizationName
    ),
    recipientAddressCountryId: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.country.value
    ),
    recipientPostalCode: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.postalCode
    ),
    recipientRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.receiverInfo.region, true)
    ),
    recipientRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.receiverInfo.region, false)
    ),
    recipientAddress1: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.address1
    ),
    recipientAddress2: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.address2
    ),
    recipientPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.phone.countryCode.value
    ),
    recipientPhoneNumber: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.phone.phoneNumber
    ),
    // 販売情報
    currencyId: commonUtil.nullEmptyFormatNull(
      clientData.saleInfo.currency.value
    ),
    saleDate: commonUtil.nullEmptyFormatNull(clientData.saleInfo.saleDate),
    // フッター
    consumptionTax10: String(
      commonUtil.nullEmptyFormat(totalList.tax10.tax, 0)
    ),
    consumptionTax8: String(commonUtil.nullEmptyFormat(totalList.tax8.tax, 0)),
    discount: String(commonUtil.nullEmptyFormat(totalList.discount, 0)),
    comission: String(commonUtil.nullEmptyFormat(totalList.shipping, 0)),
    // 商品
    productList: tmpProductList,
    // 備考
    note: commonUtil.nullEmptyFormatNull(privateRemarks),
    billingNote: commonUtil.nullEmptyFormatNull(clientRemarks)
  }

  // copyInvoiceInfoにチェックが入っている場合は請求書情報を受取人情報に上書き
  if (clientData.receiverInfo.copyInvoiceInfo) {
    result.recipientName = result.billingName
    result.recipientOrganizationName = result.billingOrganizationName
    result.recipientAddressCountryId = result.billingAddressCountryId
    result.recipientPostalCode = result.billingPostalCode
    result.recipientRegionId = result.billingRegionId
    result.recipientRegion = result.billingRegion
    result.recipientAddress1 = result.billingAddress1
    result.recipientAddress2 = result.billingAddress2
    result.recipientPhoneNumberCountryId = result.billingPhoneNumberCountryId
    result.recipientPhoneNumber = result.billingPhoneNumber
  }

  return result
}
export default { request }
